export default {
  storyboardScreens: [
    {
      imageFile: "07_Learn_More.jpg",
      title: "",
      text: "",
      coordinates: {
        left: "",
        top: "",
        right: "",
        bottom: ""
      },
      screenId: "L07",
      hasNext: false
    }
  ]
};
